<div class="modal-content">
  <div class="dialog-body">
    <div class="dialog-title">Confirm Withdrawal</div>
    @if (checkedEntriesCount === 1) {
      <div>
        @if (selectedDestination?.closedLoopRestricted && selectedDestination?.disabled) {
          <div>
            <p>
              <span class="emphasize">{{ getSelectedWithdrawalDestinationText() }}</span> is level but at least one
              other payment destination is not yet level.
            </p>
          </div>
        }
        @if (selectedDestination?.closedLoopRestricted && !selectedDestination?.disabled && isClosedLoopMaxExceeded) {
          <div>
            <p>
              <span class="emphasize">{{ getSelectedWithdrawalDestinationText() }}</span> has
              <span class="emphasize">{{ selectedDestination?.closedLoopMaximum }}</span> remaining until level and at
              least one other payment destination is not yet level.
            </p>
          </div>
        }
        <div style="text-align: center">
          <span class="emphasize warning-text">Are you sure you want to proceed?</span>
        </div>
        @if (checkedEntriesCount === 1) {
          <div mat-dialog-actions class="action-buttons">
            <button mat-raised-button [color]="'primary'" (click)="acceptWithdrawal()" data-id="dialogProceedBtn">
              Proceed
            </button>
            <button mat-raised-button [color]="'warn'" (click)="cancel()" data-id="dialogCancelBtn">Cancel</button>
          </div>
        }
      </div>
    }
    @if (checkedEntriesCount !== 1) {
      <div>
        <div style="text-align: center">
          <span class="emphasize warning-text">Only one request can be processed at a time!</span>
        </div>
        @if (checkedEntriesCount !== 1) {
          <div mat-dialog-actions class="action-buttons">
            <button mat-raised-button [color]="'primary'" (click)="cancel()" data-id="dialogCancelBtn">OK</button>
          </div>
        }
      </div>
    }
  </div>
</div>
